export enum EventType {
  PRE = "Pre",
  EVENT = "Event",
  POST = "Post",
}

export const EVENT_TYPE_LABELS: Record<string, string> = {
  [EventType.PRE]: "ก่อนติดตั้งงาน Event",
  [EventType.EVENT]: "ติดตั้ง (เข้าตรวจสอบ)",
  [EventType.POST]: "รื้อถอน (ชำระเงิน-คงค้าง)",
};
